import { maxBy, minBy } from 'lodash'

const getMinOrMax = (markersObj, minOrMax, latOrLng) => {
  const position = latOrLng === 'lat' ? 1 : 0
  if (minOrMax === 'max') {
    return maxBy(markersObj, item => {
      if (
        ((((item || '').geometry || '').coordinates || '')[position] || '') !==
        ''
      ) {
        return item.geometry.coordinates[position]
      }
    }).geometry.coordinates[position]
  }
  return minBy(markersObj, item => {
    if (
      ((((item || '').geometry || '').coordinates || '')[position] || '') !== ''
    ) {
      return item.geometry.coordinates[position]
    }
  }).geometry.coordinates[position]
}

export const getBounds = markersObj => {
  const maxLat = getMinOrMax(markersObj, 'max', 'lat')
  const minLat = getMinOrMax(markersObj, 'min', 'lat')
  const maxLng = getMinOrMax(markersObj, 'max', 'lng')
  const minLng = getMinOrMax(markersObj, 'min', 'lng')

  const southWest = [minLng, minLat]
  const northEast = [maxLng, maxLat]

  return [southWest, northEast]
}

export const allEqual = arr =>
  arr.every(
    v =>
      v.geometry.coordinates.join(',') === arr[0].geometry.coordinates.join(',')
  )

export const allEqualDistance = arr =>
  arr.every(
    v =>
      v.properties.distance_from_intersection ===
      arr[0].properties.distance_from_intersection
  )

export const getDefaultPolygon = bounds => {
  const SW = [bounds._sw.lng, bounds._sw.lat]
  const NE = [bounds._ne.lng, bounds._ne.lat]
  const SE = [bounds._sw.lng, bounds._ne.lat]
  const NW = [bounds._ne.lng, bounds._sw.lat]
  return [SW, SE, NE, NW, SW]
}



// WEBPACK FOOTER //
// ./src/components/Map/MapUtils/index.js